import { Component } from '@angular/core';

@Component({
  selector: 'app-changes-carrier-invite',
  templateUrl: './changes-carrier-invite.component.html',
  styleUrls: ['./changes-carrier-invite.component.scss'],
})
export class ChangesCarrierInviteComponent {

  constructor() { }

}
